import { AlertModalController } from '../component/Modal/Controller/AlertModalController';
import { ConfirmModalController } from '../component/Modal/Controller/ConfirmModalController';
import { TrasnferConfirmModalController } from '../component/Modal/Controller/TransferConfirmModalController';
import { LoadingModalController } from '../component/Modal/Controller/LoadingModalController';
import { OtpModalController } from '../component/Modal/Controller/OtpModalController'


export default function (modalStore) {
    const modalController = modalStore.methods.getModalController()

    const initModal = function () {
        modalController.setAlertModal(new AlertModalController());
        modalController.setConfirmModal(new ConfirmModalController());
        modalController.setTransferConfirmModal(new TrasnferConfirmModalController());
        modalController.setLoadingModal(new LoadingModalController());
        //Other core modal
        modalController.setOtpModal(new OtpModalController());

        // console.log(modalController)
    }

    initModal()

    return {
        initModal
    }
}
